import React, { useState, useReducer, useMemo } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { makeStyles } from '@material-ui/core/styles';
import { reducer, generateInitialWidgetState } from './config';

const useStyles = makeStyles({
  stepper: {
    margin: '30px 0px',
    width: '100%',
    padding: '0px'
  },
  headerColor: {
    color: '#fff'
  }
});

const DashboardStepper = ({
  titles,
  labels,
  dispatchDashboard,
  dashboardData,
  handleSteps,
  isUpdate,
  baseWidgetWidth,
  setBaseWidgetWidth,
  baseWidgetId,
  setWhichPopup,
  connector: Connector,
  iconComponent,
  handleWidgetClose,
  panelIndex
}) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const {
    benchmarks,
    masterObjectId,
    masterObjectTypeId,
    dateRangeTypeId,
    endDate,
    startDate
  } = dashboardData;

  const initialState = useMemo(
    () =>
      generateInitialWidgetState({
        benchmarks,
        masterObjectId,
        masterObjectTypeId,
        dateRangeTypeId,
        endDate,
        startDate,
        baseWidgetWidth
      }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const [widgetState, dispatchWidget] = useReducer(reducer, initialState);

  return (
    <Box width="100%">
      <Box bgcolor="#2e6292" p={2}>
        <Typography variant="h5" className={classes.headerColor}>
          {titles[activeStep]}
        </Typography>
      </Box>
      <Box width="100%" px={2}>
        <Stepper
          activeStep={activeStep}
          className={classes.stepper}
          alternativeLabel
          connector={<Connector />}
        >
          {labels.map(label => (
            <Step key={label}>
              <StepLabel StepIconComponent={iconComponent}>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        {handleSteps({
          activeStep,
          setActiveStep,
          dispatchDashboard,
          dashboardData,
          widgetState,
          dispatchWidget,
          isUpdate,
          baseWidgetWidth,
          setBaseWidgetWidth,
          baseWidgetId,
          setWhichPopup,
          handleWidgetClose,
          panelIndex
        })}
      </Box>
    </Box>
  );
};

DashboardStepper.propTypes = {
  titles: PropTypes.arrayOf(PropTypes.string).isRequired,
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  dashboardData: PropTypes.shape({
    description: PropTypes.string,
    masterObjectId: PropTypes.number,
    masterObjectTypeId: PropTypes.number,
    slots: PropTypes.string,
    dateRangeTypeId: PropTypes.number,
    endDate: PropTypes.string,
    startDate: PropTypes.string,
    benchmarks: PropTypes.arrayOf(
      PropTypes.shape({
        benchmarkId: PropTypes.number,
        name: PropTypes.string
      })
    )
  }),
  dispatchDashboard: PropTypes.func,
  baseWidgetWidth: PropTypes.number,
  setBaseWidgetWidth: PropTypes.func,
  baseWidgetId: PropTypes.string,
  setWhichPopup: PropTypes.func,
  handleSteps: PropTypes.func,
  handleWidgetClose: PropTypes.func,
  isUpdate: PropTypes.bool,
  connector: PropTypes.node.isRequired,
  iconComponent: PropTypes.node.isRequired,
  panelIndex: PropTypes.number.isRequired
};

DashboardStepper.defaultProps = {
  dashboardData: {},
  dispatchDashboard: null,
  handleWidgetClose: null,
  baseWidgetWidth: null,
  setBaseWidgetWidth: null,
  baseWidgetId: null,
  setWhichPopup: null,
  handleSteps: null,
  isUpdate: null
};
export default DashboardStepper;
